import type { SVGProps } from 'react'

interface ContractEditIconProps extends SVGProps<SVGSVGElement> {}

export function ContractEditIcon(props: ContractEditIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      fill="currentColor"
      {...props}
    >
      <path d="M360-600v-80h360v80zm0 120v-80h360v80zm120 320H200zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22-4 22.5-13 20.5L683-80zm300-263-37-37zM620-140h38l121-122-18-19-19-18-122 121zm141-141-19-18 37 37z" />
    </svg>
  )
}
